import apiInputService from "services/apiInputService";
import {
  DocumentAttachment,
  DocumentAttachmentPaginatedResponse,
  PaginatedDocumentByZIDQuery,
} from "./@types";
import { useQuery } from "@tanstack/react-query";

const fetch = async ({
  zID,
  fieldglassId,
  active,
  params,
}: PaginatedDocumentByZIDQuery): Promise<DocumentAttachmentPaginatedResponse> => {
  const { data }: any = await apiInputService.get(
    `/documentattachment/zidentifier/${zID}/fieldglassId/${fieldglassId}`,
    {
      params: {
        ...params,
        active,
      },
    },
  );

  try {
    const decodeDocsName = data?.docs?.map((doc: DocumentAttachment) => {
      return { ...doc, name: decodeURI(doc?.name) };
    });

    return {
      ...data,
      docs: decodeDocsName,
    } as DocumentAttachmentPaginatedResponse;
  } catch (error) {
    return {
      ...data,
      docs: data?.docs,
    };
  }
};

export const useGetPaginatedDocumentAttachments = (
  query: PaginatedDocumentByZIDQuery,
  options?: any,
) =>
  useQuery(
    [query.zID, query.fieldglassId, query.active, query.params],
    () => fetch(query),
    {
      ...options,
      staleTime: 0,
    },
  );
